export default {
  signInUrl: 'https://partners.sit.pt.playstation.net/sign-in',
  clientId: '0oacyhd0b6cxtnXtw0h7',
  environmentName: 'sit',
};
